import { Component } from '@angular/core';
import './app.component.css'

@Component({
  selector: 'app-root',
  template: require('./app.component.html')
})
export class AppComponent {
  title = 'app';
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts